import textBodyL from '@fukku/styles/texts/textBodyL.module.css'
import textBodyS from '@fukku/styles/texts/textBodyS.module.css'
import type { PriceClasses } from '../../types'

const classesDefault: PriceClasses = {
	price: textBodyL.className,
	firstCrossedOutPrice: '',
	crossedOutPrices: '',
	discountRate: textBodyS.className,
	additionalPrice: '',
	additionalFirstCrossedOutPrice: '',
	additionalCrossedOutPrices: '',
}

export const getPriceClasses = (classes?: PriceClasses) =>
	({ ...classesDefault, ...classes }) as PriceClasses
